// Client-side scoring for Open/Demo mode (no server call)

export function calculateScoresClient(answers) {
  const capQuestions = [1, 2, 3, 4, 5];
  const colQuestions = [6, 7, 8, 9, 10];
  const enQuestions = [11, 12, 13, 14, 15];

  const avg = (ids) => {
    const scores = ids.map((q) => answers[q] || 3);
    return scores.reduce((a, b) => a + b, 0) / scores.length;
  };

  const capAvg = avg(capQuestions);
  const colAvg = avg(colQuestions);
  const enAvg = avg(enQuestions);

  const capScore = ((capAvg - 1) / 4) * 100;
  const colScore = ((colAvg - 1) / 4) * 100;
  const enScore = ((enAvg - 1) / 4) * 100;

  const tpi = Math.pow(
    Math.max(capScore, 1) * Math.max(colScore, 1) * Math.max(enScore, 1),
    1 / 3
  );

  return {
    capability_avg: Math.round(capAvg * 100) / 100,
    collaboration_avg: Math.round(colAvg * 100) / 100,
    energy_avg: Math.round(enAvg * 100) / 100,
    capability_score: Math.round(capScore * 10) / 10,
    collaboration_score: Math.round(colScore * 10) / 10,
    energy_score: Math.round(enScore * 10) / 10,
    teampower_index: Math.round(tpi * 10) / 10,
  };
}
